import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import sample_downloadFile from "../../../assets/download/sample_bulkupload.xlsx";
import { BulkUplode_bg_image } from "../../../assets/images/images";
import { useAuth } from "../../../features/auth/AuthContext";
import { addBulkProfile } from "../../../state/actions/addBulkProfileAction";
import { resetaddbulkProfile } from "../../../state/reducers/addBulkProfileReducer";
import UploadFile from "../../UploadFile/UploadFile";
import "./bulkUplode.css";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import {checkCorruption} from "../../../utils/FileUploadS3"
import ExcelJS from "exceljs";

const BulkUplode = ({ toggleshowAddProfile, entity }) => {
  const [base64, setBase64] = useState(null);
  const [error, setError] = useState(false);
  const [fileStatus, setFileStatus] = useState(null); 
  const { token } = useAuth();
  const dispatch = useDispatch();
  const { school_id } = useSelector((state) => state.globalState);
  const addbulkprofile = useSelector((state) => state.addbulkProfile);

  const submitHandler = () => {
    if (base64 === null) {
      setError(true);
    } else {
      setError(false);
      bullProfileUploadRequest();
    }
  };

  const handleFileValidation = async (file) => {
  if (!file) {
    setBase64(null);
    setFileStatus(null);
    return;
  }
const validateExcelFileStrict = async (file) => {
  try {
    
    // ❌ Empty file
    if (!file || file.size === 0) {
      return {
        isValid: false,
        error: "File is empty",
      };
    }

    const buffer = await file.arrayBuffer();
    const bytes = new Uint8Array(buffer);

    // ✅ 1. ZIP signature check (xlsx must be zip)
    const isZip = bytes[0] === 0x50 && bytes[1] === 0x4b;
    if (!isZip) {
      return {
        isValid: false,
        error: "Invalid Excel file structure",
      };
    }

    // ✅ 2. Parse Excel
    // Security: migrated from `xlsx` (had unfixable HIGH CVEs) to `exceljs`.
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    if (!workbook.worksheets || workbook.worksheets.length === 0) {
      return {
        isValid: false,
        error: "No sheets found in Excel",
      };
    }

    // ✅ 3. Check sheet data
    // (Previously used XLSX.utils.sheet_to_json — commented out, no behavioural change.)


    // ✅ VALID FILE
    return {
      isValid: true,
    };
  } catch (err) {

    // Password protected or corrupted
    if (
      err?.message?.toLowerCase().includes("password") ||
      err?.message?.toLowerCase().includes("encrypted")
    ) {
      return {
        isValid: false,
        error: "File is password protected",
      };
    }

    return {
      isValid: false,
      error: "File is corrupted or invalid",
    };
  }
}; 
const result = await validateExcelFileStrict(file);



  if (result.isValid) {
    setBase64(file);
    setFileStatus('valid');
  } else {
    setBase64(null);
    setFileStatus('corrupted');
    toast.error(
      result.isProtected
        ? `${file.name} is password protected.`
        : `${file.name} is corrupted or invalid.`
    );
  }
};
  const bullProfileUploadRequest = () => {
    const req = {
      school_id,
      role: entity === "Student" ? 1 : 2,
      file: base64,
    };

    dispatch(addBulkProfile(req, token));
  };

  useEffect(() => {
    const failedErrorMessage =
      "Oops, something went wrong. Please try again later.";

    if (addbulkprofile?.message?.length) {
      toast.success(addbulkprofile?.message, {
        position: "top-center",
      });
      toggleshowAddProfile();
    } else if (addbulkprofile?.error?.length) {
      toast.error(failedErrorMessage, {
        position: "top-center",
      });
      dispatch(resetaddbulkProfile());
    }
  }, [addbulkprofile]);

  useEffect(() => {
    return () => {
      dispatch(resetaddbulkProfile());
    };
  }, []);

  return (
    <>
      <div className="BulkUplode-section">
        <div className="BulkUplode-wrapper">
          <div className="BulkUplode-image">
            <img src={BulkUplode_bg_image} alt="" />
          </div>
          <div className="BulkUplode-button-wrapper">
            {fileStatus === "valid" && (
              <div>
                <span
                  className="File_Uploaded"
                  style={{ color: "green", fontSize: "13px" }}
                >
                  <FileDownloadDoneIcon /> 
                  File Uploaded :
                </span>
                <span className="relative ml-2 text-green-600 group">
                  <span className="block max-w-[150px] truncate">
                    {base64.name}
                  </span>
                </span>
              </div>
            )}

            {fileStatus === "corrupted" && (
              <div>
                <span style={{ color: "red", fontSize: "13px" }}>
                  ❌ File is corrupted or invalid. Please upload a valid file.
                </span>
              </div>
            )}
            <a href={sample_downloadFile} download="sample_file.xlsx">
              <div className="BulkUplode-button-folder">
                <span>
                  <i class="fa-solid fa-table-cells"></i>
                </span>
                <p>Download Table format</p>
              </div>
            </a>
            <UploadFile setBase64={setBase64} onFileSelect={handleFileValidation} />
            {base64 === null && error && (
              <p style={{ color: "red" }}> Upload Excel File</p>
            )}
          </div>
        </div>
        <div className="add-profile-btn-container">
          <button
            type="button"
            className="add-profile-save-btn add-profile-close-btn"
            onClick={toggleshowAddProfile}
          >
            Close
          </button>
          <button
            type="button"
            className="add-profile-save-btn"
            onClick={submitHandler}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
};
export default BulkUplode;
